<style>
    .rulescusmanage .ivu-transfer-list{
        height: 360px;
    }
    .hidenspan{
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        word-break: break-all;
    }
</style>
<template>
    <div>
        <compWrapper title="已选条件" theme="primary">
            <!-- 基础信息 -->
            <Form :label-width="110" class="rulescusmanage" :model="formData">
                <div v-if="showFlag.channelflag">
                    <header class="detail-title">{{$t('global.common.base_information',{defaultValue:'基本信息'})}}</header>
                    <FormItem label='渠道账号' :rules="required" prop="targetAccountList">
                        <div v-if="type=='query'">
                            <p v-for="(item,index) in formData.targetAccountList" :key="index">
                                {{ item }}
                            </p>
                        </div>
                        <Transfer
                            v-else
                            style="height: 360px;
                            display: flex;
                            justify-content: center;
                            margin-top:40px;
                            margin-left:-75px"
                            :data="accountList"
                            filterable
                            :target-keys="formData.targetAccountList"
                            :list-style="listStyle"
                            :render-format="renderList"
                            :filter-method="filterMethod"
                            @on-change="handleAccountChange"
                        ></Transfer>
                    </FormItem>
                </div>
                <!-- 仓储物流 -->
                <div v-if="showFlag.carrierflag">
                    <header class="detail-title">{{$t('uc.global_catelog.v2_storage',{defaultValue:'仓储'})}}{{$t('uc.global_catelog.v2_logistics',{defaultValue:'物流'})}}</header>
                    <FormItem label='发货方式' :rules="required" prop="carrier">
                        <div v-if="type=='query'" class="hidenspan" >
                            <Tooltip :content="carrierList.join(',')" max-width="400">
                                <span v-for="(item,index) in carrierList" :key="index">{{item}},</span>
                            </Tooltip>
                        </div>
                        <!-- <Select v-else v-model="formData.carrier" style="padding-right:20px" multiple filterable clearable >
                            <Option
                                v-for="item in handleSysShippingCode"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.label }}
                            </Option>
                        </Select> -->
                        <compMultipleSelect 
                            v-else
                            :options="handleSysShippingCode" 
                            :modelValue="formData.carrier" 
                            :placeholder="'请选择'" 
                            @update:modelValue="changeShip"
                            :vstyle="'max-width:400px'"
                            :isShowCheckAll="false">
                        </compMultipleSelect>
                    </FormItem>
                </div>
                <!-- 产品信息 -->
                <header v-if="showFlag.lineflag || showFlag.prodflag || showFlag.oneprodflag || showFlag.totalprodflag || showFlag.prodattrflag" class="detail-title">{{$t('global.common.product_info',{defaultValue:'产品信息'})}}</header>
                <FormItem label='项目' v-if="showFlag.lineflag" :rules="required" prop="targetProductList">
                    <div v-if="type=='query'">
                        <p v-for="(item,index) in formData.targetProductList" :key="index">
                            {{ item }}
                        </p>
                    </div>
                    <Transfer
                            v-else
                            style="height: 360px;
                            display: flex;
                            justify-content: center;
                            margin-top:40px;
                            margin-left:-75px"
                            :data="productList"
                            filterable
                            :target-keys="formData.targetProductList"
                            :list-style="listStyle"
                            :render-format="renderList"
                            @on-change="handleProductChange"
                        ></Transfer>
                </FormItem>
                <FormItem label='产品' v-if="showFlag.prodflag" :rules="required" prop="prodErpskuList">
                    <div v-if="type=='query'">
                        <p v-for="(item,index) in detailDatas.skuList" :key="index">
                            {{ item.content }}
                        </p>
                    </div>
                    <Input v-else style="padding-right:20px" v-model="formData.prodErpskuList" type="textarea" placeholder="输入sku编码，多个换行输入"></Input>
                </FormItem>
                <FormItem label='单产品重量' v-if="showFlag.oneprodflag" :rules="required" prop="oneprodChoose1">
                    <div v-if="type=='query'">
                        <span v-if="singerSkuWeight1">{{singerSkuWeight1.content}} g {{singerSkuWeight1.sign == '>' ? '<' : '<='}} </span> 单产品重量 <span v-if="singerSkuWeight2"> {{singerSkuWeight2.sign}} {{singerSkuWeight2.content}} g</span> 
                    </div>
                    <Row v-else>
                        <Col span="12">
                            <div>
                                <Checkbox v-model="formData.oneprodChoose1" @on-change="clickvalue(1)"></Checkbox>
                                <Select v-model="formData.oneprodvalue1" :disabled="!formData.oneprodChoose1" style="width:90px">
                                    <Option value=">">大于</Option>
                                    <Option value=">=">大于等于</Option>
                                </Select>
                                <Input v-model="formData.oneprodWeight1" :disabled="!formData.oneprodChoose1" style="width:100px">
                                    <span style="font-size:18px" slot="suffix">g</span>
                                </Input>
                            </div>
                        </Col>
                        <Col span="12">
                            <Checkbox v-model="formData.oneprodChoose2" @on-change="clickvalue(2)"></Checkbox>
                            <Select v-model="formData.oneprodvalue2" :disabled="!formData.oneprodChoose2" style="width:90px">
                                <Option value="<">小于</Option>
                                <Option value="<=">小于等于</Option>
                            </Select>
                            <Input v-model="formData.oneprodWeight2" :disabled="!formData.oneprodChoose2" style="width:100px">
                                <span style="font-size:18px" slot="suffix">g</span>
                            </Input>
                        </Col>
                    </Row>

                </FormItem>
                <FormItem label='产品总重量' v-if="showFlag.totalprodflag" :rules="required" prop="totalprodChoose1">
                    <div v-if="type=='query'">
                        <span v-if="totalSkuWeight1">{{totalSkuWeight1.content}} g {{totalSkuWeight1.sign == '>' ? '<' : '<='}} </span> 产品总重量 <span v-if="totalSkuWeight2"> {{totalSkuWeight2.sign}} {{totalSkuWeight2.content}} g</span> 
                    </div>
                    <Row v-else>
                        <Col span="12">
                            <Checkbox v-model="formData.totalprodChoose1" @on-change="clickvalue(3)"></Checkbox>
                            <Select v-model="formData.totalprodvalue1" :disabled="!formData.totalprodChoose1" style="width:90px">
                                <Option value=">">大于</Option>
                                <Option value=">=">大于等于</Option>
                            </Select>
                            <Input v-model="formData.totalprodWeight1" :disabled="!formData.totalprodChoose1" style="width:100px">
                                <span style="font-size:18px" slot="suffix">g</span>
                            </Input>
                            
                        </Col>
                        <Col span="12">
                            <Checkbox v-model="formData.totalprodChoose2" @on-change="clickvalue(4)"></Checkbox>
                            <Select v-model="formData.totalprodvalue2" :disabled="!formData.totalprodChoose2" style="width:90px">
                                <Option value="<">小于</Option>
                                <Option value="<=">小于等于</Option>
                            </Select>
                            <Input v-model="formData.totalprodWeight2" :disabled="!formData.totalprodChoose2" style="width:100px">
                                <span style="font-size:18px" slot="suffix">g</span>
                            </Input>
                        </Col>
                    </Row>
                </FormItem>
                <FormItem label='产品属性' v-if="showFlag.prodattrflag" :rules="required" prop="isFragile">
                    <div v-if="type == 'query'">
                        {{formData.isFragile == 1 ? '是易碎':'不是易碎'}}
                    </div>
                    <div v-else>
                        <Checkbox v-model="formData.isFragile">易碎</Checkbox>
                    </div>
                </FormItem>
                
            </Form>
        </compWrapper>
        <compWrapper title="设定动作" theme="primary">
            <Form :label-width="110" class="rulescusmanage" :model="formData">
                <!-- 设定动作 -->
                <header class="detail-title">设定动作</header>
                <FormItem label='保险产品' :rules="required" prop="insuranceServiceId">
                    <div v-if="type == 'query'">{{insuranceServiceCode}}</div>
                    <Select v-else style="padding-right:20px" v-model="formData.insuranceServiceId">
                        <Option v-for="(item,index) in insuranceList" :key="index" :value="item.value">{{item.label}}</Option>
                    </Select>
                </FormItem>
                <FormItem label='投保类型' :rules="required" prop="insuranceType">
                    <div v-if="type == 'query'">
                        {{detailDatas.insuranceType == 0 ? '销售价格':'采购价格'}}
                    </div>
                    <RadioGroup v-else  v-model="formData.insuranceType">
                        <Radio label="1">
                            <span class="font-12">采购价格</span>
                        </Radio>
                        <Radio label="0">
                            <span class="font-12">销售价格</span>
                        </Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label='加成比例' style="padding-right:20px" :rules="required" prop="insuranceProportion">
                    <div v-if="type == 'query'">{{detailDatas.insuranceProportion}}</div>
                    <!-- <InputNumber v-else style="width:100%;" 
                    :formatter="value => `${value}%`"
                    :parser="value => value.replace('%', '')" 
                    :min="100" :max="130" v-model="formData.insuranceProportion"></InputNumber> -->
                    <Input v-else v-model="formData.insuranceProportion" type="number" :min="100">
                        <!-- <span slot="append">%</span> -->
                    </Input>
                    <div v-if="type != 'query'" class="color-error" >加成比例填写请在100-130之间</div>
                </FormItem>
            </Form>
        </compWrapper>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
    HttpGetAllCustomerIdCode,
    HttpFindAllByInsuranceList,
} from "@/service/credit";

import {
    HttpAccountList,
    HttpProductList,
} from "@mods/service/dictionary";

export default {
    props:["showFlag","detailDatas","type"],
    data(){
        return {
            required: [{
                required: true,
                message: this.$t('global.common.information_empty', { defaultValue: "该信息不能为空,请填写" })
            }],
            formData:{
                targetAccountList:[],
                targetProductList:[],
                carrier:[],
                prodErpskuList:"",
                insuranceType:"",
                insuranceProportion:100,
                isFragile:false,
                insuranceServiceId:null,
                oneprodChoose1:false,
                oneprodvalue1:'>',
                oneprodChoose2:false,
                oneprodvalue2:'<',
                totalprodChoose1:false,
                totalprodvalue1:'>',
                totalprodChoose2:false,
                totalprodvalue2:'<',
            },
            handleSysShippingCode:[],
            carrierList:[],
            insuranceServiceCode:'',
            singerSkuWeight1:null,
            singerSkuWeight2:null,
            totalSkuWeight1:null,
            totalSkuWeight2:null,
            getInsuranceList:[],
            getAccountList:[],
            getProductList:[],
        }
    },
    created(){
        
        HttpGetAllCustomerIdCode().then(res => {
            let serviceCodeList = res.data.map(item => {
                return {
                    label: `${item.code}(${item.carrierServiceName})`,
                    value: item.code,
                    attach: {
                        ...item
                    }
                }
            })
            this.handleSysShippingCode = serviceCodeList;
            }, err => {
            this.$Message.error(err.message)
        })
        HttpFindAllByInsuranceList().then(res=>{
            this.getInsuranceList = res.data.map(item=>{
                return {
                    value: item.id, label: item.serviceName+'('+item.serviceCode+')', attach: {
                    status: item.status,
                    serviceCode:item.serviceCode,
                }}
            })
        })
        HttpAccountList().then(res=>{
            this.getAccountList = res.data.map(item=>{
                return {
                    value: item.id,
                    label: `${item.title}(${item.flag})`,
                }
            })
        })
        HttpProductList().then(res=>{
            this.getProductList = res.data.map(item=>{
                return {
                    value: item.id,
                    label: `${item.name}(${item.description})`,
                }
            })
        })
    },
    computed:{
        // ...mapGetters("dictionary", [
        //     "getProductList",
        //     "getAccountList",
        // ]),
        insuranceList () {
            return this.getInsuranceList.filter(item => {
                return item.attach.status === 0
            })
        },
        accountList(){
            return this.getAccountList.map((item) => {
                return {
                    label: item.label,
                    key: item.value,
                };
            });
        },
        productList(){
            return this.getProductList.map((item) => {
                return {
                    label: item.label,
                    key: item.value,
                };
            });
        }, 
        listStyle() {
            return {
                width: "30%",
                minWidth: "260px",
            };
        },
        renderFormat(item) {
            return item.description
                ? `${item.label}-${item.description}`
                : item.label;
        },
    },
    watch:{
        detailDatas: {
			deep: true,
			handler(val) {
                setTimeout(()=>{
                    this.handleData(val)
                },600)
			}
		},
    },
    
    methods:{
        // 切换发货方式
        changeShip(val){
            this.formData.carrier = val;
        },
        clickvalue(val){
            switch(val){
                case 1: if(!this.formData.oneprodChoose1){this.formData.oneprodWeight1 = ''} ; break;
                case 2: if(!this.formData.oneprodChoose2){this.formData.oneprodWeight2 = ''}; break;
                case 3: if(!this.formData.totalprodChoose1){this.formData.totalprodWeight1 = ''}; break;
                case 4: if(!this.formData.totalprodChoose2){this.formData.totalprodWeight2 = ''}; break;
            }
        },
        handleData(val){
            // console.log(val)
            if (this.type === "query") {
                this.formData.targetAccountList = val.channelList.map(
                    (item) => {
                        let result = this.accountList.filter(
                            (accountItem) => {
                                return accountItem.key == item.content;
                            }
                        )[0];
                        if (!result) return {};
                        return result.label;
                    }
                );
                this.formData.targetProductList = val.productLineList.map(
                    (item) => {
                        let result = this.productList.filter(
                            (accountItem) => {
                                return accountItem.key == item.content;
                            }
                        )[0];
                        if (!result) return {};
                        return result.label;
                    }
                );
                this.carrierList = val.carrierCodeList.map(item=>{
                    return this.handleSysShippingCode.filter(json=>{
                        if(json.value == item.content){
                            return json
                        }
                    })[0].label
                })
                // console.log(this.insuranceList,'this.insuranceList')
                this.insuranceServiceCode = this.insuranceList.filter(item=>{
                    if(val.insuranceServiceId == item.value){
                        return item
                    }
                })[0].label
                // 单产品重量
                if(val.singerSkuWeight.length>0){
                    if(val.singerSkuWeight[0]){
                        if(val.singerSkuWeight[0].sign == '>' || val.singerSkuWeight[0].sign == '>='){
                            this.singerSkuWeight1 = val.singerSkuWeight[0].sign ? val.singerSkuWeight[0]:null
                        }else{
                            this.singerSkuWeight2 = val.singerSkuWeight[0].sign ? val.singerSkuWeight[0]:null
                        }
                    }
                    if(val.singerSkuWeight[1]){
                        this.singerSkuWeight2 = val.singerSkuWeight[1].sign ? val.singerSkuWeight[1]:null
                    }
                }

                // 产品总重量
                if(val.totalSkuWeight.length>0){
                    if(val.totalSkuWeight[0]){
                        if(val.totalSkuWeight[0].sign == '>' || val.totalSkuWeight[0].sign == '>='){
                            this.totalSkuWeight1 = val.totalSkuWeight[0].sign ? val.totalSkuWeight[0]:null
                        }else{
                            this.totalSkuWeight2 = val.totalSkuWeight[0].sign ? val.totalSkuWeight[0]:null
                        }
                    }
                    if(val.totalSkuWeight[1]){
                        this.totalSkuWeight2 = val.totalSkuWeight[1].sign ? val.totalSkuWeight[1]:null
                    }
                }

                this.formData.isFragile = val.productAttribute? val.productAttribute.isFragile == 1 ? true : false :this.showFlag.prodattrflag = false
            }
            if(this.type === "edit"){
                this.formData.targetAccountList = val.channelList.map(item=>{
                    return Number(item.content);
                })
                this.formData.carrier = val.carrierCodeList.map(item=>{
                    return item.content;
                })
                this.formData.targetProductList = val.productLineList.map(item=>{
                    return Number(item.content);
                })
                this.formData.insuranceServiceId = val.insuranceServiceId;
                let prodarr = val.skuList.map(item=>{
                    return item.content
                })
                prodarr = prodarr.join(',')
                this.formData.prodErpskuList = prodarr.replace(/,/g, "\n");

                if(val.singerSkuWeight.length>0){
                    if(val.singerSkuWeight[0]){
                        if(val.singerSkuWeight[0].sign == '>' || val.singerSkuWeight[0].sign == '>='){
                            this.formData.oneprodChoose1 = true;
                            this.formData.oneprodvalue1 = val.singerSkuWeight[0].sign
                            this.formData.oneprodWeight1 = val.singerSkuWeight[0].content
                        }else{
                            this.formData.oneprodChoose2 = true;
                            this.formData.oneprodvalue2 = val.singerSkuWeight[0].sign
                            this.formData.oneprodWeight2 = val.singerSkuWeight[0].content
                        }
                    }
                    if(val.singerSkuWeight[1]){
                        this.formData.oneprodChoose2 = true;
                        this.formData.oneprodvalue2 = val.singerSkuWeight[1].sign
                        this.formData.oneprodWeight2 = val.singerSkuWeight[1].content
                    }
    
                }

                if(val.totalSkuWeight.length>0){
                    if(val.totalSkuWeight[0]){
                        if(val.totalSkuWeight[0].sign == '>' || val.totalSkuWeight[0].sign == '>='){
                            this.formData.totalprodChoose1 = true;
                            this.formData.totalprodvalue1 = val.totalSkuWeight[0].sign
                            this.formData.totalprodWeight1 = val.totalSkuWeight[0].content
                        }else{
                            this.formData.totalprodChoose2 = true;
                            this.formData.totalprodvalue2 = val.totalSkuWeight[0].sign
                            this.formData.totalprodWeight2 = val.totalSkuWeight[0].content
                        }
                    }
                    if(val.totalSkuWeight[1]){
                        this.formData.totalprodChoose2 = true;
                        this.formData.totalprodvalue2 = val.totalSkuWeight[1].sign
                        this.formData.totalprodWeight2 = val.totalSkuWeight[1].content
                    }
                }

                this.formData.isFragile = val.productAttribute? val.productAttribute.isFragile == 1 ? true : false :this.showFlag.prodattrflag = false

                this.formData.insuranceType = String(val.insuranceType);

                this.formData.insuranceProportion = val.insuranceProportion;
            }
        },
        renderList(item) {
            return item.label;
        },
        handleAccountChange(newTargetKeys, direction, moveKeys) {
            this.formData.targetAccountList = newTargetKeys;
        },
        handleProductChange(newTargetKeys, direction, moveKeys) {
            this.formData.targetProductList = newTargetKeys;
        },
        // 添加自定义搜索函数,不区分大小写
        filterMethod(data, query) {
            return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        },
    }
}
</script>